import React from 'react'
import styled from 'styled-components'
import { object } from 'prop-types'
import { MapContainer, TileLayer, Marker } from 'react-leaflet'

const MapWrapper = styled.div`
  margin-bottom: 1rem;
`

function Map({ resource }) {
  if (resource.mapParams) {
    const position = [resource.mapParams.lat, resource.mapParams.lng]

    return (
      <MapWrapper>
        <MapContainer center={position} zoom={16} scrollWheelZoom={false}>
          <TileLayer
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Marker position={position} />
        </MapContainer>
      </MapWrapper>
    )
  }
  return null
}

Map.propTypes = {
  resource: object,
}

export default Map
